import React from 'react';
import { ReactElement } from 'react';
import { IRoute } from 'interfaces/routesInt';
import urls from '../urls';
import ManageRoutes from 'routes/manageRoute';

const publicPageElement: ReactElement = <ManageRoutes />;

const commonElements = {
  element: publicPageElement,
  isProtected: false,
};

const publicRoutes: IRoute[] = [
  {
    path: urls.landingPage,
    key: 'landing-page',
    ...commonElements,
  },
  {
    path: urls.login,
    key: 'login',
    ...commonElements,
  },
  {
    path: urls.register,
    key: urls.register,
    ...commonElements,
  },
  {
    path: urls.resetPassword,
    key: urls.resetPassword,
    ...commonElements,
  },
  {
    path: urls.superAdminLogin,
    key: 'super-admin-login',
    ...commonElements,
  },
  {
    path: '/sup-admin/login',
    key: 'sup-admin-login-alias',
    ...commonElements,
  },
  {
    path: '/sup-admin',
    key: 'sup-admin-alias',
    ...commonElements,
  },
  {
    path: urls.guestOrder,
    key: 'guest-order',
    ...commonElements,
  },
];

export default publicRoutes;
